import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PageResponse, Role } from '../models/models';

@Injectable({
    providedIn: 'root'
})
export class RoleService {
    private apiUrl = `${environment.apiUrl}/roles`;

    constructor(private http: HttpClient) { }

    getAll(): Observable<Role[]> {
        return this.http.get<Role[]>(this.apiUrl);
    }

    getPage(search = '', page = 0, size = 10, sort = 'name,asc'): Observable<PageResponse<Role>> {
        const params = new HttpParams()
            .set('search', search)
            .set('page', String(page))
            .set('size', String(size))
            .set('sort', sort);

        return this.http.get<PageResponse<Role>>(`${this.apiUrl}/page`, { params });
    }

    getById(id: number): Observable<Role> {
        return this.http.get<Role>(`${this.apiUrl}/${id}`);
    }

    create(role: Role): Observable<Role> {
        return this.http.post<Role>(this.apiUrl, role);
    }

    update(id: number, role: Role): Observable<Role> {
        return this.http.put<Role>(`${this.apiUrl}/${id}`, role);
    }

    delete(id: number): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/${id}`);
    }

    canDelete(id: number): Observable<boolean> {
        return this.http.get<boolean>(`${this.apiUrl}/${id}/can-delete`);
    }
}
